export function getApiErrorMessage(payload, fallback = 'Erreur serveur') {
  if (!payload || typeof payload !== 'object') return fallback;
  if (payload.error && typeof payload.error === 'object' && payload.error.message) return payload.error.message;
  if (payload.detail && typeof payload.detail === 'object' && payload.detail.message) return payload.detail.message;
  if (typeof payload.detail === 'string' && payload.detail) return payload.detail;
  if (typeof payload.error === 'string' && payload.error) return payload.error;
  if (typeof payload.message === 'string' && payload.message) return payload.message;
  return fallback;
}

export async function readJsonSafe(response) {
  try {
    return await response.json();
  } catch {
    return null;
  }
}

export function apiFetch(endpoint, options = {}) {
  const headers = { ...options.headers };
  const hasFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;

  if (!hasFormData && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  return fetch(endpoint, { ...options, headers, credentials: 'include' });
}

export async function apiFetchJson(endpoint, options = {}, fallbackMessage = 'Erreur serveur') {
  const response = await apiFetch(endpoint, options);
  const payload = await readJsonSafe(response);

  if (!response.ok || payload?.success === false) {
    const error = new Error(getApiErrorMessage(payload, `${fallbackMessage} (${response.status})`));
    error.status = response.status;
    error.payload = payload;
    throw error;
  }

  if (payload && typeof payload === 'object' && payload.success === true && 'data' in payload) {
    return payload.data;
  }

  return payload;
}
